export var ConditionOperators;
(function (ConditionOperators) {
    ConditionOperators["EQUAL"] = "===";
    ConditionOperators["NOT_EQUAL"] = "!==";
    ConditionOperators["LESS_THAN"] = "<";
    ConditionOperators["GREATER_THAN"] = ">";
    ConditionOperators["LESS_THAN_OR_EQUAL"] = "<=";
    ConditionOperators["GREATER_THAN_OR_EQUAL"] = ">=";
    ConditionOperators["IN"] = "IN";
    ConditionOperators["NOT_IN"] = "NOT_IN";
    ConditionOperators["IS_EMPTY"] = "IS_EMPTY";
    ConditionOperators["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
})(ConditionOperators || (ConditionOperators = {}));
